import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col" }

import { watch, ref, computed } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { EMIT } from '@/enum';
import { useTenantStore, useAuthStore } from '@/store';
import { storeToRefs } from 'pinia';

interface TenantForm {
  name: string | undefined;
}
/**
 * The general reference object to contain the form data so vuelidate works
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'General',
  setup(__props, { emit: __emit }) {

const tenantStore = useTenantStore();
const authStore = useAuthStore();
const { tenant } = storeToRefs(tenantStore);
const editing = ref('');

const tenantForm = ref<TenantForm>({ name: '' });

/**
 * need to watch the tenant store for val changes
 */
watch(tenantStore, () => {
  tenantForm.value.name = tenant?.value?.name;
  resetForm();
});

/**
 * The required validation rules.
 */
const rules = { name: { required, minLength: minLength(3) } };

/**
 * Define all the available emit events.
 */
const emit = __emit;

/**
 * Reset the vuelidate dirty status for all keys.
 */
const resetDirty = () => v$.value.$reset();

/**
 * Initialize the vuelidate instance.
 */
const v$ = useVuelidate(rules, tenantForm);

/**
 * reset the stype for the outline and footer class and dirty
 */
const resetForm = () => {
  editing.value = '';
  resetDirty();
};

const onSave = () => {
  emit(EMIT.SAVE, tenantForm.value.name as string);
  resetForm();
};

const onCancel = () => {
  tenantForm.value.name = tenant?.value?.name;
  resetForm();
};

const setStyle = () => {
  editing.value = 'editing';
};

const isMasterTenant = computed(() => tenant?.value?.id === authStore.masterTenantId);

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["general", editing.value])
  }, {
    header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("h2", null, "General", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { for: "name" }, "Name", -1)),
            (_unref(tenantStore).loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "2.3rem",
                  class: "w-full"
                }))
              : (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  id: "name",
                  modelValue: _unref(v$).name.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                  class: "w-full",
                  disabled: isMasterTenant.value,
                  onInput: setStyle
                }, null, 8, ["modelValue", "disabled"]))
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_unref(v$).$dirty)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_AppButton, {
              id: "cancel_btn",
              type: "secondary",
              text: "Cancel",
              onClick: onCancel
            }),
            _createVNode(_component_AppButton, {
              id: "save_btn",
              type: "primary",
              text: "Save",
              disabled: _unref(v$).$invalid,
              onClick: onSave
            }, null, 8, ["disabled"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})